import React from 'react';
import { connect } from 'react-redux';
import './PromoSplash.scss';
import CodesparkLogo from '../../../components/global/CodesparkLogo';

function PromoSplashComponent(props) {
  const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

  return (
    <div  className="promo-ad-section small-12 medium-12 large-6">
      <div className="logo"><CodesparkLogo /></div>
      <h1 className="title">{props.webOffer.offerTitle ? props.webOffer.offerTitle : 'Unlock a world of creativity!'}</h1>
      <h5 className="subtitle">{props.webOffer.offerSubtitle ? props.webOffer.offerSubtitle : "What's included"}</h5>
      <div className="small-12 feature-bullet-points">
      <ul>
        <li>
          <img src={`${imgURL}/global/icons/checkmark-white.svg`} alt="checkmark" />
          <span className="list-text">Unlimited coding challenges</span>
        </li>
        <li>
          <img src={`${imgURL}/global/icons/checkmark-white.svg`} alt="checkmark" />
          <span className="list-text">New skills EVERY WEEK</span>
        </li>
        <li>
          <img src={`${imgURL}/global/icons/checkmark-white.svg`} alt="checkmark" />
          <span className="list-text">100s of education puzzles</span>
        </li>
        <li>
          <img src={`${imgURL}/global/icons/checkmark-white.svg`} alt="checkmark" />
          <span className="list-text">Unlimited access to creativity suite</span>
        </li>
        <li>
          <img src={`${imgURL}/global/icons/checkmark-white.svg`} alt="checkmark" />
          <span className="list-text">Access for up to 3 children</span>
        </li>
      </ul>
      </div>
      <div className="badges grid-x align-justify">
        <div className="large-4 small-4">
          <img className="award-icon left" alt="" src={`${imgURL}/flagship/how-it-works/awards/parents_choice_gold_2019.png`} />
        </div>
        <div className="large-4 small-4">
          <a href="https://www.kidsafeseal.com/certifiedproducts/codespark_thefoos_app.html" target="_blank" rel="noopener noreferrer">
            <img className="single-award" alt="codeSpark - coding for kids is certified by the kidSAFE Seal Program." src="https://www.kidsafeseal.com/sealimage/1730524102862329251/codespark_thefoos_app_large_whitetm.png" />
          </a>
        </div>
        <div className="large-4 small-4">
          <img className="award-icon right" alt="" src={`${imgURL}/flagship/teacher-landing/awards/brain-toy.png`} />
        </div>
      </div>
      <div className="promo-image"></div>
    </div>
  )
}

const mapStateToProps = state => ({
  webOffer: state.appState.webOffer
});

export default connect(mapStateToProps)(PromoSplashComponent);
